import React, {useEffect, useState} from "react";
import {Button, Col, Form, Row} from "react-bootstrap";
import {FormLabelRequiredAsterisk} from "Components/Form/FormLabelRequiredAsterisk";
import {AllChildSelect} from "../../Components/Child/AllChildSelect";

interface Props {
    onSave: (formData: { [key: string]: any }) => void,
    year?: number,
    monthNumber?: number,
    childId?: string,
    description?: string,
    amount?: number,
}

export const MonthlyFeeModificationForm: React.FC<Props> = (props) => {

    const [formData, setFormData] = useState<{ [key: string]: any }>({
        year: props.year ?? '',
        monthNumber: props.monthNumber ?? '',
        childId: props.childId ?? '',
        amount: props.amount ?? '',
        description: props.description ?? ''
    })
    const [formErrors, setFormErrors] = useState<{ [key: string]: any }>({
        year: false,
        monthNumber: false,
        childId: false,
        amount: false
    })
    const [submited, setSubmited] = useState<boolean>(false)

    const validate = (): boolean => {
        let errors: number = 0
        let currentFormErrors = {}

        if (!formData.year || formData.year < 2020 || formData.year > 2100) {
            currentFormErrors = {
                ...currentFormErrors,
                year: true
            }
            errors++
        }

        if (!formData.monthNumber || formData.monthNumber < 1 || formData.monthNumber > 12) {
            currentFormErrors = {
                ...currentFormErrors,
                monthNumber: true
            }
            errors++
        }

        if (!formData.childId) {
            currentFormErrors = {
                ...currentFormErrors,
                childId: true
            }
            errors++
        }

        if (formData.amount === '' || formData.amount === undefined) {
            currentFormErrors = {
                ...currentFormErrors,
                amount: true
            }
            errors++
        }

        if (errors === 0) {
            return true
        }

        setFormErrors(currentFormErrors)
        return false
    }

    const save = () => {
        if (!submited) {
            setSubmited(true)
        }

        if (!validate()) {
            return
        }

        props.onSave(formData)
    }

    useEffect(() => {
        if (submited) {
            validate()
        }
    }, [formData])

    useEffect(() => {
        setFormData({
            year: props.year ?? '',
            monthNumber: props.monthNumber ?? '',
            childId: props.childId ?? '',
            amount: props.amount ?? '',
            description: props.description ?? ''
        })
    }, [props.monthNumber, props.childId, props.amount, props.description, props.year]);

    return (
        <>
            <Col>
                <Form.Group className={"mb-3"}>
                    <Form.Label>
                        Año
                        <FormLabelRequiredAsterisk/>
                    </Form.Label>
                    <Form.Control
                        type="number"
                        min={2020}
                        max={2100}
                        placeholder="Año"
                        value={formData.year}
                        onChange={(e) => {
                            setFormData({
                                ...formData,
                                year: parseInt(e.target.value)
                            })
                        }}
                        isInvalid={formErrors.year}
                    />
                    <Form.Control.Feedback type="invalid">
                        El año es obligatorio
                    </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className={"mb-3"}>
                    <Form.Label>
                        Mes
                        <FormLabelRequiredAsterisk/>
                    </Form.Label>
                    <Form.Control
                        type="number"
                        min={1}
                        max={12}
                        placeholder="Mes (1-12)"
                        value={formData.monthNumber}
                        onChange={(e) => {
                            setFormData({
                                ...formData,
                                monthNumber: parseInt(e.target.value)
                            })
                        }}
                        isInvalid={formErrors.monthNumber}
                    />
                    <Form.Control.Feedback type="invalid">
                        El mes es obligatorio y debe estar entre 1 y 12.
                    </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className={"mb-3"}>
                    <Form.Label>
                        Niño
                        <FormLabelRequiredAsterisk/>
                    </Form.Label>
                    <AllChildSelect
                        value={formData.childId}
                        onChange={(value: any) => {
                            setFormData({
                                ...formData,
                                childId: value ? value.value : ''
                            })
                        }}
                    />
                    {formErrors.childId && (
                        <div className="invalid-feedback d-block">
                            El niño es obligatorio.
                        </div>
                    )}
                </Form.Group>

                <Form.Group className={"mb-3"}>
                    <Form.Label>
                        Importe
                        <FormLabelRequiredAsterisk/>
                    </Form.Label>
                    <Form.Control
                      type="number"
                      placeholder="Importe"
                      step="0.01"
                      value={formData.amount}
                      onChange={(e) => {
                        const val = e.target.value;
                        setFormData({
                          ...formData,
                          amount: val === '' ? '' : parseFloat(val)
                        });
                      }}
                      isInvalid={formErrors.amount}
                    />
                    <Form.Control.Feedback type="invalid">
                        El importe es obligatorio.
                    </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className={"mb-3"}>
                    <Form.Label>
                        Descripción
                    </Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={3}
                        placeholder="Descripción"
                        value={formData.description}
                        onChange={(e) => {
                            setFormData({
                                ...formData,
                                description: e.target.value
                            })
                        }}
                    />
                </Form.Group>

                <Row>
                    <Col className={"d-flex justify-content-end"}>
                        <Button
                            className={"purple-btn"}
                            onClick={save}
                        >
                            Guardar
                        </Button>
                    </Col>
                </Row>
            </Col>
        </>
    )
}

